//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosPost } from '../../axios/axios.js'
import { getChangedProperties } from './bussinessProcessObjectChanges.js'
import BussinessProcessEventsForm from './BusinessProcessEvents/BussinessProcessEventsForm.vue'

function getDateTimeValidateFn (actionPropertyValidation, propertyConfig) {
  if (propertyConfig && propertyConfig.type === 'datetime') {
    return function (val) {
      if (val && actionPropertyValidation && actionPropertyValidation.moreOrEqualCurrent) {
        return val >= Date.now()
      }
      return true
    }
  }
}

export default {
  props: {
    button: {
      type: Object,
      default: null
    },
    record: {
      type: Object,
      required: true
    },
    mobile: {
      type: Boolean,
      default: false
    },
    save: {
      type: Boolean,
      default: false
    },
    close: {
      type: Boolean,
      default: false
    },
    copy: {
      type: Boolean,
      default: false
    },
    update: {
      type: Boolean,
      default: false
    },
    requestProperties: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data: function () {
    return {
    }
  },
  computed: {
    hasChanges: function () {
      const record = this.record
      if (record) {
        const changedProperties = getChangedProperties(record.request, record.requestInitial, this.requestProperties)

        return Object.keys(changedProperties).length !== 0
      } else {
        return false
      }
    }
  },
  methods: {
    onClickUpdateButton: function () {
      if (this.hasChanges) {
        this.$d_ask({
          callback: (data, action) => {
            if (action === 'yes') {
              this.$emit('update')
            }
          },
          header: 'Обновить?',
          warning: ['Несохранённые изменения будут потеряны'],
          buttons: {
            yes: 'Да',
            no: 'Нет'
          }
        })
      } else {
        this.$emit('update')
      }
    },
    onClickCloseButton: function () {
      const saveBtn = this.record.actions.find(action => action.id === 'save')

      if (saveBtn && this.hasChanges) {
        this.$d_ask({
          callback: (data, action) => {
            if (action === 'yes') {
              this.onClickButton(saveBtn)
            } else if (action === 'no') {
              if (this.update) {
                this.$emit('update')
              } else {
                this.$emit('close')
              }
            }
          },
          header: 'Сохранить изменения?',
          warning: ['Несохранённые изменения будут потеряны'],
          buttons: {
            yes: 'Да',
            no: 'Нет',
            cancel: 'Отмена'
          }
        })
      } else {
        this.$emit('close')
      }
    },
    onClickButton: function (button) {
      if (button.id === 'save' && !this.hasChanges) {
        return
      }
      this.validateFields(button).then(() => {
        return this.saveFilesChanges()
      }).then((result) => {
        if ((result && result.status !== 'positive')) {
          return Promise.reject(Error('Ошибка загрузки файлов заявки'))
        }

        const record = this.record

        const props = {
          action: button.id,
          forms: {}, // почему было [] ?
          request: getChangedProperties(record.request, record.requestInitial, this.requestProperties),
          report: {}
        }

        const complexActionData = {
          action: button,
          actionProps: props,
          bpContextId: record.bp.id,
          lastChangeTime: record.bp.changeTime || null
        }

        this.processAction(complexActionData, button)
      })
    },
    processAction: function (complexActionData, action, actionType = 'action') {
      if ((!action.forms || action.forms.length === 0 || action.id === 'save' || !this.mobile && action.forms.length === 1 && action.forms[0].contentType === 'empty') && (!action.warnings || !action.warnings.length) && !action.confirmationRequired && actionType !== 'error') {
        return this.changePBState(complexActionData)
      } else {
        return new Promise((resolve, reject) => {
          const dialog = this.$d.dialog(this).show({
            maximizedOnNarrow: true,
            // TODO maximized: mobile && config.props && config.props.length !== 0
            persistent: true,
            noWrap: true,
            contentWidth: 560,
            contentComponent: BussinessProcessEventsForm,
            contentProps: {
              record: this.record,
              mobile: this.mobile,
              initConfig: {
                callback: (resultForms) => {
                  if (resultForms) {
                    Object.assign(complexActionData.actionProps.forms, resultForms)
                  }
                  if (action.confirmationRequired) {
                    complexActionData.manuallyConfirmed = true
                  }
                  return this.changePBState(complexActionData)
                },
                actionType: actionType,
                forms: action.forms,
                title: action.name,
                warnings: action.warnings,
                warningFormat: action.warningFormat,
                btnOkName: 'Подтвердить'
              }
            },
            componentHandlers: {
              applied: (applyResult) => {
                if (applyResult === 'bp-cancel') { // результат из следующей формы
                  return
                }
                dialog.hide()
                resolve()
              },
              cancel: () => {
                dialog.hide()
                // this.$emit('close')
                resolve('bp-cancel')
              },
              error: e => {
                // dialog.hide()
                reject(new Error(e && e.message || 'Ошибка выполнения действия'))
              }
            }
          })
        })
      }
    },
    changePBState: function (complexActionData) {
      this.$q.loading.show({
        spinnerColor: 'blue-11'
      })

      const bodyFormData = new FormData()
      if (complexActionData.bpContextId) {
        bodyFormData.set('objectId', complexActionData.bpContextId)
      }

      const complexActionProps = complexActionData.actionProps || {}
      complexActionProps.checkReprocess = true
      complexActionProps.ignoreReprocessCreationFixation = true
      complexActionProps.clientTime = Date.now()
      if (complexActionData.manuallyConfirmed) {
        complexActionProps.manuallyConfirmed = true
      }
      if (complexActionData.lastChangeTime) {
        complexActionProps.lastChangeTime = complexActionData.lastChangeTime
      }
      bodyFormData.set('props', JSON.stringify(complexActionProps))

      const rootAction = complexActionData.action
      const businessProcessKey = rootAction.businessProcessKey || 'record'

      return axiosPost({
        url: `/service/delta/${businessProcessKey}/${rootAction.nextBPState}`,
        data: bodyFormData,
        onSuccess: (response) => {
          this.$q.notify({
            type: 'positive',
            message: `Успешно выполнено действие «${rootAction.name}»`,
            progress: true,
            timeout: 3000
          })

          const result = response.data.result
          const id = result.id || null
          this.$emit('update', id)

          return result
        },
        onFailure: (response) => {
          if (response.type === 'reaction') {
            return response
          } else {
            const message = response.message || 'Ошибка выполнения процесса'
            this.$q.notify({
              type: 'negative',
              message: message,
              progress: true,
              timeout: 8000
            })

            return Promise.reject(Error(message))
          }
        }
      }).finally(() => {
        this.$q.loading.hide()
      }).then(responseResult => {
        const reaction = responseResult.reaction || responseResult.data && responseResult.data.reaction || null
        if (reaction) {
          if ((reaction.key === 'action' || reaction.key === 'error') && reaction.action) {
            if (responseResult.message) {
              reaction.action.name = responseResult.message
            }

            if (this.record.prepareAction) {
              this.record.prepareAction(reaction.action)
            }

            return this.processAction(complexActionData, reaction.action, reaction.key)
          } else if (this.record.processCustomAction) {
            this.record.processCustomAction(reaction, this)
          }
        }
        return Promise.resolve(responseResult)
      })
    },
    validateFields: function (button) {
      const validFieldLabels = []
      const additionalValidFieldMessages = []
      const validFieldKeys = []

      if (button.requestValidation) {
        button.requestValidation.sort((a, b) => a.blank ? -1 : 1)
        button.requestValidation.forEach(requestValidationField => {
          const propertyKey = requestValidationField.property
          const value = this.record.request[propertyKey]

          const propertyConfig = this.requestProperties[propertyKey]
          if (propertyConfig) {
            propertyConfig.serverRequiredFn = function () {
              return requestValidationField.required
            }

            propertyConfig.requiredFn = propertyConfig.customRequiredFn || propertyConfig.serverRequiredFn

            propertyConfig.dateTimeValidateFn = getDateTimeValidateFn(requestValidationField, propertyConfig) || null

            if (!propertyConfig.blank) {
              validFieldKeys.push(propertyKey)

              if (propertyConfig.additionalValidateFn && !propertyConfig.additionalValidateFn(value)) {
                additionalValidFieldMessages.push(propertyConfig.getAdditionalValidateMessage())
              }

              if (propertyConfig.dateTimeValidateFn && !propertyConfig.dateTimeValidateFn(value)) {
                additionalValidFieldMessages.push(propertyConfig.dateTimeValidateMessage)
              }

              if (!propertyConfig.validateFn(value)) {
                validFieldLabels.push(propertyConfig.label)
              }
            }
          }
        })
      }

      this.$emit('validate', validFieldKeys)

      if (validFieldLabels.length === 0 && additionalValidFieldMessages.length === 0) {
        return Promise.resolve('Валидация полей успешна')
      } else {
        if (validFieldLabels.length > 0) {
          const message = 'Не заполнены обязательные поля: ' + validFieldLabels.map(val => '"' + val + '"').join(', ') + '.\n'

          this.$q.notify({
            type: 'negative',
            message: message,
            progress: true,
            timeout: 10000
          })
        }
        if (additionalValidFieldMessages.length) {
          this.$q.notify({
            type: 'negative',
            message: additionalValidFieldMessages.join('\n'),
            progress: true,
            timeout: 10000
          })
        }
        return Promise.reject(Error('Не пройдена валидация полей'))
      }
    },
    saveFilesChanges () {
      const record = this.record
      const filesGroupsContainer = record.request._filesGroups
      if (filesGroupsContainer.hasChanges()) {
        return filesGroupsContainer.saveFilesChanges({
          notify: true,
          target: this
        })
      }
      return Promise.resolve()
    }
  }
}

